var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgMerchIcon = function SvgMerchIcon(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#29AAE1",
    d: "M8.613 6.354c-.504 0-.915-.404-.915-.898v-.67c0-.495.411-.9.915-.9.502 0 .914.405.914.9v.67c0 .494-.411.898-.914.898",
    transform: "translate(6 5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B6B3D9",
    d: "M3.384 2.468c-.503 0-.914-.405-.914-.899V.9C2.47.405 2.88 0 3.384 0c.503 0 .915.404.915.899v.67c0 .495-.412.899-.915.899",
    transform: "translate(6 5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D86C6",
    d: "M3.384 3.355C1.518 3.355 0 4.847 0 6.68v6.89h1.539V6.68c0-1 .828-1.813 1.845-1.813 1.018 0 1.846.814 1.846 1.813v6.89h1.537v.143l.002-.103V6.68c0-1.833-1.519-3.325-3.385-3.325",
    transform: "translate(6 5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D86C6",
    d: "M8.613 7.242c-.68 0-1.314.198-1.844.538-.9.576-1.505 1.561-1.54 2.684v3.146-.04h1.538v-3.003c0-.025 0-.05.002-.075.04-.965.851-1.738 1.844-1.738 1.017 0 1.845.813 1.845 1.813v3.003h1.539v-3.003c0-1.834-1.518-3.325-3.384-3.325",
    transform: "translate(6 5)"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMerchIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/merch_icon.1ba53011.svg";
export { ForwardRef as ReactComponent };